import styled from 'styled-components';

export const PageTitleWrapper = styled.div` 
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    padding: 15px 0;
    margin-bottom: 15px;
`;

export const Title = styled.h1`
    font-size: 24px;
    font-weight: 500;
`;

export const PageTitleActionBar = styled.div`
    display: grid;
    grid-template-columns: auto auto; 
`;

/* Prawa strona nagłówka: akcje + główny przycisk razem, dosunięte do prawej.
   Wcześniej wrapper miał trzy dzieci w space-between, więc akcje lądowały
   na środku między tytułem a przyciskiem. */
export const PageTitleRight = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
`;
